import { render, staticRenderFns } from "./roleBinding.vue?vue&type=template&id=58bceb9e&"
import script from "./roleBinding.vue?vue&type=script&lang=js&"
export * from "./roleBinding.vue?vue&type=script&lang=js&"
import style0 from "./roleBinding.vue?vue&type=style&index=0&id=58bceb9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports